import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import Icon from 'components/atoms/Icon';
import MbTooltip from 'components/atoms/MbTooltip';

const useStyles = makeStyles((theme) => ({
  infoWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > p': {
      margin: '0 2px 0 0',
    },
  },
}));

const InfoTitleArea = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    title,
    tooltipTitle,
    tooltipType,
    children,
    iconType = 'faInfoCircle',
    iconColor = '',
    placement = 'right-start',
  } = props;

  let tooltipStr = '';
  if (typeof tooltipType !== 'undefined') {
    if (
      tooltipType === 'MOB_SESSION_ROAS' ||
      tooltipType === 'TRGT_MOB_SESSION_ROAS'
    ) {
      tooltipStr = t('세션 매출 중 모비온 광고를 통해 발생한 매출');
    } else if (
      tooltipType === 'SESSION_ROAS' ||
      tooltipType === 'TRGT_SESSION_ROAS'
    ) {
      tooltipStr = t(
        '모비온 광고 클릭 후 브라우저를 닫지 않고 결제한 매출로 타사 매출이 포함됨'
      );
    } else if (
      tooltipType === 'DIRECT_ROAS' ||
      tooltipType === 'TRGT_DIRECT_ROAS'
    ) {
      tooltipStr = t(
        '모비온 광고 클릭 후 직접매출시간(Default 24시간) 이내 매출'
      );
    } else if (tooltipType === 'ROAS' || tooltipType === 'TRGT_ROAS') {
      tooltipStr = t('모비온 광고 클릭 후 총매출시간 (Default 30일) 이내 매출');
    } else if (tooltipType === 'ECPM' || tooltipType === 'TRGT_ECPM') {
      tooltipStr = t('광고 1,000회 노출당 광고수익');
    } else {
      tooltipStr = tooltipTitle;
    }
  } else {
    tooltipStr = tooltipTitle;
  }

  return (
    <div className={classes.infoWrap}>
      <p>{title}</p>
      <MbTooltip title={tooltipStr} placement={placement}>
        {children}
        {iconType === 'fainfoCircle' && (
          <Icon
            icon={'faInfoCircle'}
            color={
              iconColor !== ''
                ? iconColor
                : iconColor === 'graph'
                ? '#c5c6d0'
                : '#77787d'
            }
            style={{ marginLeft: 2 }}
          />
        )}
      </MbTooltip>
    </div>
  );
};

export default InfoTitleArea;
